module.exports = __webpack_public_path__ + "img/icon_self_restriction.413748e2.png";